var _rect, _path, _rect2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#A0D911"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.66211H11C9.89543 8.66211 9 9.60082 9 10.7588V23.3388C9 24.4968 9.89543 25.4355 11 25.4355H21C22.1046 25.4355 23 24.4968 23 23.3388V10.7588C23 9.60082 22.1046 8.66211 21 8.66211H19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6.56445,
    width: 6,
    height: 4.19335,
    rx: 2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.9512H15.5C14.6716 14.9512 14 15.6552 14 16.5237C14 17.3921 14.6716 18.0962 15.5 18.0962H16.5C17.3284 18.0962 18 18.8002 18 19.6687C18 20.5372 17.3284 21.2412 16.5 21.2412H14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.2407C17 20.6884 16.5523 20.2407 16 20.2407C15.4477 20.2407 15 20.6884 15 21.2407H17ZM15 22.289C15 22.8413 15.4477 23.289 16 23.289C16.5523 23.289 17 22.8413 17 22.289H15ZM17 13.9023C17 13.3501 16.5523 12.9023 16 12.9023C15.4477 12.9023 15 13.3501 15 13.9023H17ZM15 14.9507C15 15.503 15.4477 15.9507 16 15.9507C16.5523 15.9507 17 15.503 17 14.9507H15ZM15 21.2407V22.289H17V21.2407H15ZM15 13.9023V14.9507H17V13.9023H15Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.66e7355d4b790baab2e015da9ad9c7f7.svg";
export { ForwardRef as ReactComponent };